<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <!-- <base-img
        :src="require('@/assets/logo.png')"
        class="mr-3 hidden-xs-only"
        contain
        max-width="200"
        width="100%"
      /> -->
      <v-btn :to="'/'" text color="white">
        <base-img
          :src="require('@/assets/logo.png')"
          contain
          max-width="200"
          width="100%"
        />
      </v-btn>

      <v-spacer />

      <div>
        <v-tabs class="hidden-sm-and-down" optional>
          <v-tab
            v-for="(name, i) in items"
            :key="i"
            :to="{ name }"
            :exact="name === 'Home'"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            {{ name }}
          </v-tab>
          <v-tab
            :to="'/signup'"
            active-class="text--primary"
            class="font-weight-bold white--text v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light deep-purple--text text--accent-4 mx-1 my-2"
            min-width="96"
            text
          >
            {{ $i18n.t("Sign Up") }}
          </v-tab>
          <v-tab
            :to="'/login'"
            active-class="text--primary"
            class="font-weight-bold v-btn v-btn--contained theme--light primary mx-1 my-2"
            min-width="96"
            text
          >
            {{ $i18n.t("Login") }}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("@/views/home/layouts/Drawer"),
  },

  data: () => ({
    drawer: null,
    items: ["Home", "Transporter", "Shipper", "About", "Reach Us"],
  }),
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

  .v-tab
    &::before
      display: none
</style>
